import { NextButton, PrevButton, usePrevNextButtons } from "components/UI/CarouselArrowButtons";
import useEmblaCarousel from "embla-carousel-react";

export default function Carousel({ imagePreviews, qrcode }) {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    align: "start",
    slidesToScroll: 1,
  });

  const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } =
    usePrevNextButtons(emblaApi);
  return (
    <div>
      <div className="relative">
        <div className="overflow-hidden" ref={emblaRef}>
          <div className="flex">
            {imagePreviews &&
              imagePreviews.length > 0 &&
              imagePreviews.map((entry, index) => (
                <div key={index} className="flex-[0_0_auto] w-[240px] h-[320px] md:w-[480px] md:h-[720px] mr-[19px]">
                  <div className="h-full relative">
                    <img
                      draggable="false"
                      className="w-full h-full object-cover object-center rounded-xl border border-global-theme shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05)]"
                      loading="lazy"
                      src={entry}
                      alt={`Article ${index + 1}`}
                    />
                  </div>
                </div>
              ))}
          </div>
        </div>
        {qrcode && (
          <div className="w-[140px] h-[140px] left-5 bottom-5 absolute flex justify-center items-center bg-global-theme rounded-[5px] border border-global-divider-soft ">
            <img
              className="w-[122.5px] h-[122.719px] border border-global-divider-soft object-contain object-center"
              src={qrcode}
              alt="QR Code"
            />
          </div>
        )}
      </div>

      {imagePreviews && imagePreviews.length > 0 && (
        <div className="flex justify-start items-center pt-4">
          <div className="gap-4 flex">
            <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
            <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
          </div>
        </div>
      )}
    </div>
  );
}
